import { useCurrency } from "@/hooks/useCurrency";
import { Platform, PlatformPriceList } from "@/models/GameResell";
import { useLocale } from "@/store/locale-store";
import { GePrice } from "@/v2-components/GePrice";
import MetaColoredIcon from "@/v2-components/core/icon/meta-colored-icon";
import SteamColoredIcon from "@/v2-components/core/icon/steam-colored-icon";
import { GameUtil } from "@/utils/GameUtil";

export default function GameResellPriceTag({
  platformPrice,
}: {
  platformPrice: PlatformPriceList;
}) {
  const currency = useCurrency();
  const { countryCode } = useLocale();

  const price = GameUtil.findPrice(platformPrice.priceList, currency);

  if (!price) {
    return null;
  }

  return (
    <div className="flex gap-1">
      {platformPrice.platform === Platform.Steam ? (
        <SteamColoredIcon />
      ) : (
        <MetaColoredIcon />
      )}

      <div className="flex items-center gap-1">
        <p className="text-base text-coolgray-50 line-through">
          <GePrice
            amount={price.price}
            currency={price.currency}
            countryCode={countryCode}
            hideCurrency
          />
        </p>
        <p className="text-base font-600">
          <GePrice
            amount={price.price - price.discount}
            currency={price.currency}
            countryCode={countryCode}
          />
        </p>
      </div>
    </div>
  );
}
